import React from 'react';
import { FileText } from 'lucide-react';

const AdminPages = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 px-6" data-testid="admin-pages-page">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold mb-8" data-testid="pages-title">Custom Pages</h1>

        <div className="glass-card p-12 text-center">
          <FileText className="w-16 h-16 mx-auto mb-4 text-muted-foreground" />
          <h2 className="text-2xl font-bold mb-4">Custom Page Builder</h2>
          <p className="text-muted-foreground mb-8">
            Create custom landing pages and sales funnels for your store.
            This feature is coming soon!
          </p>
          <p className="text-sm text-muted-foreground">
            For now, you can manage your products and courses from the respective sections.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminPages;
